import { getInstagramUsers, GetInstagramUsersParams, InstagramUser } from '@round/api';
import { useCallback, useState } from 'react';
import { showNotification } from '../../../helpers';

type Params = GetInstagramUsersParams;

export function useInstagramUsers({ page, page_size, id }: Params) {
    const [users, setUsers] = useState<InstagramUser[]>([]);
    const [count, setCount] = useState(0);
    const [isInitialized, setIsInitialized] = useState(false);
    const [hasError, setHasError] = useState(false);

    const fetchUsers = async (params: Params, requestInit: RequestInit) => {
        try {
            const response = await getInstagramUsers(params, requestInit);
            if (response.status === 404) {
                setHasError(true);
                showNotification(response.data.detail, 'error');
                return;
            }

            setUsers(response.data.results);
            setCount(response.data.count);
            setIsInitialized(true);
        } catch (e) {
            if (e instanceof Error && e.name === 'AbortError') {
                return;
            }
            setHasError(true);
            showNotification(`Could not fetch instagram users`, 'error');
        }
    };

    const init = useCallback(
        async (requestInit: RequestInit) => {
            await fetchUsers({ page, page_size, id }, requestInit);
        },
        [page, page_size, id]
    );

    const reset = () => {
        setUsers([]);
        setIsInitialized(false);
        setHasError(false);
    };

    return {
        users,
        count,
        isInitialized,
        isLoading: !isInitialized && !hasError,
        hasError,

        init,
        reset,
    };
}
